/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Instructions_PlaceholderInputs */



/**
* | output |
* | --- |
* | "e.g. Use an informal tone. Keep brand names in English. This is a children's cartoon." |
*
* @param {Translation_Instructions_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_instructions_placeholder = /** @type {((inputs?: Translation_Instructions_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Instructions_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ex. Utiliser un ton familier. Garder les noms de marque en anglais. Il s'agit d'un dessin animé pour enfants.")
	if (locale === "de") return /** @type {LocalizedString} */ ("z. B. Lockeren Ton verwenden. Markennamen auf Englisch belassen. Dies ist ein Kinder-Zeichentrickfilm.")
	if (locale === "it") return /** @type {LocalizedString} */ ("es. Usa un tono informale. Mantieni i nomi dei marchi in inglese. Si tratta di un cartone animato per bambini.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("напр. Используйте неформальный тон. Оставляйте названия брендов на английском. Это детский мультфильм.")
	if (locale === "es") return /** @type {LocalizedString} */ ("p. ej. Usar un tono informal. Mantener los nombres de marca en inglés. Es una serie de dibujos animados infantil.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("例如：使用口语化语气。品牌名称保留英文。这是一部儿童动画片。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("例：くだけた口調にする。ブランド名は英語のままにする。子ども向けアニメです。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उदा. अनौपचारिक लहजा रखें। ब्रांड नाम अंग्रेज़ी में रखें। यह बच्चों का कार्टून है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ex. Usar um tom informal. Manter os nomes de marcas em inglês. É um desenho animado infantil.")
	return /** @type {LocalizedString} */ ("e.g. Use an informal tone. Keep brand names in English. This is a children's cartoon.")
});